import React, { useEffect } from 'react';
import { AppState } from 'react-native';
import { locationEngine } from '../services/locationEngine';

/**
 * Mounts the single Location Engine for the whole app session. Renders only
 * `children` — location data flows through the locationEngine singleton and
 * the useLocation* hooks, not React Context, so a GPS tick never forces a
 * re-render of this provider's subtree.
 *
 * Must be mounted once above the tab navigator (which mounts/unmounts
 * screens on tab switch) so tracking survives navigation.
 */
export const LocationEngineProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    void locationEngine.start();

    const subscription = AppState.addEventListener('change', status => {
      if (status === 'active') {
        locationEngine.resume();
      } else {
        locationEngine.pause();
      }
    });

    return () => subscription.remove();
  }, []);

  return <>{children}</>;
};
